import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TableDefault from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { mobileFirstMedia as media } from '../../config/theme';

const TableWrapper = styled.div`
  /* margin-left: -25px; */
  /* margin-right: -25px; */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (${media.s}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

const Table = styled(TableDefault)`
  margin-top: 30px;
  min-width: 650px;
`;

const TableSlice = ({ data, ...rest }) => (
  <TableWrapper {...rest}>
    <Table>
      <TableHead>
        <TableRow>
          {Object.keys(data[0]).map(key => (
            <TableCell key={key} align="center">
              {key}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            {Object.values(row).map(value => (
              <TableCell key={value} align="center">
                {value}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableWrapper>
);

TableSlice.propTypes = { data: PropTypes.array.isRequired };

export default TableSlice;
